import { INK } from '../components/deck/Type'

export type EcosystemStat = {
  value: string
  label: string
  tone?: string
}

/** Documented third-party coverage + modeled global ecosystem estimates. */
export const ecosystemStats: EcosystemStat[] = [
  { value: '80+', label: 'Years of venture history' },
  { value: '10M+', label: 'Ventures' },
  { value: '100K+', label: 'Capital organizations', tone: INK.blue },
  { value: '35K+', label: 'Institutional LPs', tone: INK.blue },
  { value: '15K+', label: 'Venture programs', tone: INK.violet },
  { value: '1M+', label: 'Venture rounds', tone: INK.emerald },
  { value: '50K+', label: 'Venture-backed exits', tone: INK.gold },
  { value: '$5T+', label: 'Capital deployed', tone: INK.emerald },
]

export const ECOSYSTEM_SOURCE =
  'Figures represent documented third-party database coverage and modeled global ecosystem estimates. Categories may overlap. See appendix.'

/** Approved DiligenceGPT™ product screenshots. */
export const productShots = {
  pipelineTable:
    'https://cdn.magicpatterns.com/uploads/cpVcWzzszzzbFPLz6R7Gct/Screenshot_2026-08-13_at_11.50.47_PM.png',
  companyProfile:
    'https://cdn.magicpatterns.com/uploads/5XUTRKAmn7h7X83vbWraKs/Screenshot_2026-08-14_at_2.31.57_AM.png',
  pipelineKanban:
    'https://cdn.magicpatterns.com/uploads/7BMvUmnr5uLE4rbr5JMUXw/Screenshot_2026-08-14_at_2.32.15_AM.png',
  dealAnalysis:
    'https://cdn.magicpatterns.com/uploads/uSaDQqfG1FRcCnzXEYxifQ/Screenshot_2026-08-14_at_2.33.29_AM.png',
} as const
